import { render, staticRenderFns } from "./manage-scc-user.vue?vue&type=template&id=21fbd0e4&"
import script from "./manage-scc-user.vue?vue&type=script&lang=js&"
export * from "./manage-scc-user.vue?vue&type=script&lang=js&"
import style0 from "./manage-scc-user.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports